import React, {useMemo} from 'react';

interface AspectRatioProps extends React.HTMLAttributes<HTMLDivElement> {
  ratio: number;
}

const AspectRatio = ({ratio, children, ...props}: AspectRatioProps) => {
  const style = useMemo(
    () => ({paddingBottom: `${(1 / ratio) * 100}%`}),
    [ratio],
  );
  return (
    <div {...props}>
      <div className="relative w-full" style={style}>
        <div className="absolute inset-0">{children}</div>
      </div>
    </div>
  );
};

export default AspectRatio;
